import { iconMap } from '@/modules/system/historico/components/CamposParaIcones';
import { chavesDiffVisiveis } from '@/modules/system/historico/historico-detalhe.utils';
import { campoMap } from '@/modules/system/historico/historico.service';
import { cloneElement, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { BiEdit, BiPlusCircle, BiTrash } from 'react-icons/bi';

export function IconeAcao({ acao }: { acao: string }) {
  const size = 18;
  if (acao === 'INSERT') return <BiPlusCircle size={size} className="text-success" title="Inclusão" />;
  if (acao === 'DELETE') return <BiTrash size={size} className="text-danger" title="Exclusão" />;
  return <BiEdit size={size} className="text-warning" title="Atualização" />;
}

export function IconesCampos({ diff }: { diff: Record<string, unknown> | null | undefined }) {
  const icones = chavesDiffVisiveis(diff).flatMap((campo) => {
    const indice = campoMap[campo];
    const icone = indice != null ? iconMap[indice] : undefined;
    if (!icone) return [];
    return [<span key={campo}>{cloneElement(icone, { size: 16 })}</span>];
  });

  if (icones.length === 0) return null;
  return <span className="d-inline-flex align-items-center gap-1">{icones}</span>;
}

const camposSemLegenda = new Set([
  'senha',
  'password',
  'codigorecuperacao',
  'criadoem',
  'editadoem',
  'criadopor',
  'editadopor',
  'id',
]);

function iconesDeCampo() {
  const vistos = new Set<string>();
  return Object.entries(campoMap).flatMap(([campo, indice]) => {
    if (camposSemLegenda.has(campo) || campo.endsWith('_hash')) return [];
    const icone = iconMap[indice];
    const titulo = icone?.props.title as string | undefined;
    if (!icone || !titulo || vistos.has(titulo)) return [];
    vistos.add(titulo);
    return [{ titulo, icone }];
  });
}

export function LegendaIconesHistorico() {
  const [aberto, setAberto] = useState(false);
  const campos = iconesDeCampo();

  return (
    <div className="small text-muted d-flex flex-wrap align-items-center justify-content-end gap-3">
      <span className="d-inline-flex align-items-center gap-1">
        <BiPlusCircle size={16} className="text-success" /> Inclusão
      </span>
      <span className="d-inline-flex align-items-center gap-1">
        <BiEdit size={16} className="text-warning" /> Atualização
      </span>
      <span className="d-inline-flex align-items-center gap-1">
        <BiTrash size={16} className="text-danger" /> Exclusão
      </span>
      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setAberto(true)}>
        Legendas
      </button>
      <Modal show={aberto} onHide={() => setAberto(false)} centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Legendas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap align-items-center gap-3">
            {campos.map(({ titulo, icone }) => (
              <span key={titulo} className="d-inline-flex align-items-center gap-1">
                {cloneElement(icone, { size: 16 })}
                {titulo}
              </span>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
